<template>
  <div class="app-wrapper">
    <div class="head" />
    <div class="background">
      <!--<div class="head" />-->
      <div class="nav" v-if="authUser && getIsAuthenticated" />
      <div class="main" />
    </div>
    <div id="app" class="theme-web" :class="{'nav-open': navActive }">
      <transition name="fade">
        <div v-if="isLoading" class="loading">
          <rp-spinner />
        </div>
      </transition>

      <!-- TODO: vue can do this already... v-if or v-show (i think) -->
      <div class="section" :class="{ hidden: isLoading }">
        <Header :fullscreen="$route.meta.fullscreen" />

        <div class="inner" v-if="$route.name === 'patient-questionnaire-unauth'">
          <div class="main-container">

              <div class="router-view-wrapper" :class="{'fullscreen': $route.meta.fullscreen}">
                <transition name="fade" mode="out-in">
                  <router-view />
                </transition>
              </div>

            <Footer v-if="!$route.meta.fullscreen"/>
          </div>
        </div>

        <div class="inner" v-else>

          <side-nav @closeNav="closeNav" v-if="!$route.meta.hideSidebar" :class="`page-${this.$route.name}`" />

          <div class="main-container" :class="{'nav-open': navActive }">
            <navigation @openNav="openNav" v-if="getIsAuthenticated && !$route.meta.hideNavigation" />

              <div class="router-view-wrapper" :class="{'fullscreen': $route.meta.fullscreen}">
                <transition name="fade" mode="out-in">
                  <router-view />
                </transition>
              </div>

            <Footer v-if="!$route.meta.fullscreen"/>
          </div>
        </div>

        <server-error-modal />
      </div>
      <Onboarding v-if="getIsAuthenticated & checkIsOnboarded"/>
      <SvgSprite />
      <rp-overlay :active="showNotification">
        <div>
          <rp-notifications v-model="systemNotifications" />
        </div>
      </rp-overlay>
    </div>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import SideNav from '@/components/SideNav/SideNav'
  import Navigation from '@/components/Navigation'
  import ServerErrorModal from '@/components/ServerError'
  import Spinner from 'raypro_ui/src/components/ui/Spinner'

  import store from '@/store/'
  import * as httpErrors from 'raypro_ui/src/store/modules/httpRequests/types'
  import {mapGetters, mapMutations} from 'vuex'
  import SvgSprite from 'raypro_ui/src/components/SvgSprite.vue'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Notifications from 'raypro_ui/src/components/ui/Notification'

  import Onboarding from '@/components/Onboarding'
  import notificationMixin from 'raypro_ui/src/mixins/systemNotifications'
  import * as onboardingTypes from 'raypro_ui/src/store/modules/onboarding/types'

  export default {
    name: 'App',

    components: {
      Header,
      Footer,
      SideNav,
      Navigation,
      ServerErrorModal,
      'rp-spinner': Spinner,
      SvgSprite,
      Onboarding,
      'rp-overlay': Overlay,
      'rp-notifications': Notifications
    },

    mixins: [notificationMixin],

    data() {
      return {
        navActive: false,
        errorModal: false,
      }
    },

    mounted() {
      this.fetchSystemNotificatons()
    },


    computed: {
      ...mapGetters([
        'isLoading',
        'getIsAuthenticated',
        'authUser',
        'isOnboarded',
        'systemNotifications',
        'isAdmin'
      ]),

      checkIsOnboarded() {
        if(this.authUser) {
          return !this.isOnboarded.includes(this.authUser.id)
        }
      },
    },

    methods: {
      ...mapMutations([onboardingTypes.SYSTEM_NOTIFICATIONS, 'removeFromNotifications']),

      openNav() {
        this.navActive = true
      },

      closeNav() {
        this.navActive = false
      }
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/main.sass'
  @import '/stylesheets/helpers/mixins'

  .fade-enter-active, .fade-leave-active
    transition: opacity .3s ease-in-out

  .fade-enter, .fade-leave-to
    opacity: 0

  .slide-enter-active, .slide-leave-active
    transition: all .3s ease-in-out

  .slide-enter, .slide-leave-to
    opacity: 0
    transform: translateY(-10px)

  .app-wrapper
    .head
      z-index: 1
      width: 100%      
      height: 75px
      position: fixed
      background-color: $color-panel-bg
    .background
      position: absolute
      width: 100%
      height: 100%
      .nav
        top: 75px
        height: 50px
        position: relative
        background-color: $color-primary
      .main
        height: auto
        background-color: $color-body-bg

  #app
    position: relative
    max-width: 1200px
    margin: 0 auto 0 auto

    .section
      min-height: 100vh
      display: flex
      flex-direction: column

      .inner
        flex-grow: 1

    &.nav-open
      overflow: hidden
      height: 100%

      .side-nav
        opacity: 1.0
        transition: all .5s ease-in-out
        transform: translateX(0)
        max-height: none

        @include media($media-medium)
          transform: none

      .nav-items
        opacity: 1
        transform: translateX(0)

      .main-container
        &:before
          opacity: 1
          z-index: 1

    .server-error, .loading
      position: fixed
      top: 0
      left: 0
      right: 0
      bottom: 0
      z-index: 100
      display: flex
      justify-content: center
      align-items: center

  .inner
    display: flex

  .main-container
    position: relative
    display: flex
    flex-direction: column
    flex-basis: 100%
    min-width: 0

    &:before
      content: ''
      background: rgba(0, 0, 0, 0.75)
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      opacity: 0
      z-index: 0
      pointer-events: none
      transition: all .3s ease-in-out

    &.nav-open
      pointer-events: none

    @include media($media-medium)
      padding-left: 0

  form
    max-width: 750px
    padding: 30px
    border-radius: 5px
    color: $color-text
    background: $color-panel-bg
    box-shadow: 0 0 5px 0px $color-shadow

    a
      color: $color-primary

  .inner-form
    max-width: 100%
    padding: 10px 0 0 0
    box-shadow: none

  .create-icon
    width: 30px
    height: 30px
    cursor: pointer
    fill: $color-text-invert


  .router-view-wrapper
    flex-grow: 1
    padding: 10px 20px

    &.fullscreen
      padding: 0

  .back-link
    margin-top: 30px
    margin-bottom: 30px
    display: block
    font-size: 14px

    a
      font-weight: bold

    .sprite
      width: 20px
      height: 20px
      position: relative
      top: 5px
      fill: $color-text-invert

    @include media($media-medium)
      display: none

  .reset-link
    display: block

  .breadcrumbs-actions
    display: flex
    justify-content: flex-end
</style>



// WEBPACK FOOTER //
// src/App.vue